export const SMALL_LANG_PAYMENT_METHODS = {
  CARD: 'card',
  PAYPAL: 'paypal',
  KLARNA: 'klarna',
  AFTERPAY: 'afterpay',
  GOOGLE_PAY: 'googlepay',
  APPLE_PAY: 'applepay',
  WALLET: 'wallet',
} as const;

export const SMALL_LANG_PAYMENT_WAYS = {
  CARD: 'card',
  PAYPAL_NOW: 'pay_now',
  PAYPAL_LATER: 'pay_later',
  KLARNA_PAY_LATER: 'klarna',
  KLARNA_PAY_OVER_TIME: 'klarna_account',
  KLARNA_PAY_NOW: 'klarna_paynow',
  AFTERPAY: 'afterpaytouch',
} as const;

export const SMALL_LANG_BNPL_SITE_NAMES = ['ca', 'uk', 'de', 'fr'] as const;

export const BNPL_DISPLAY_SCENES = {
  PRODUCT_DETAIL: 'product_detail',
  CART: 'cart',
  CHECKOUT: 'checkout',
} as const;
